import teamRequestCoincidencesComponent from './teamRequestCoincidences.component';

let teamRequestCoincidencesModule = angular.module('vacations-absences.teamRequestCoincidences', [])

.component('teamRequestCoincidences', teamRequestCoincidencesComponent)

.name;

export default teamRequestCoincidencesModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidences/teamRequestCoincidences.js